import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Footer from "../../../components/Popup/_components/Footer";
import { WorldMapProvider } from "../../../contexts/WorldMapContext";
import { MAP_ELEMENT } from "../../../contexts/WorldMapContext/constants";
import { PoiService } from "../../../util/services/poi";
import { locationActions } from "../../../util/store/location/reducer";
import { selectRegion } from "../../../util/store/region/constants";
import { filterOption, renderOpts, showErrorResponse } from "../../../util/varibles/global";
import { IPois } from "../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../util/varibles/message";
import { Rule } from "../../../util/varibles/validation";
import Map from "../_components/Map";
import styles from '../style.module.scss';

const actions = {
    true: {
        api: PoiService.create,
        handle: locationActions.add,
        successCode: NotifyCode.S1,
        errorCode: NotifyCode.E22,
    },
    false: {
        api: PoiService.update,
        handle: locationActions.update,
        successCode: NotifyCode.S2,
        errorCode: NotifyCode.E35,
    }
}

const Body: React.FC<{ location?: IPois, onClose: () => void }> = ({ location, onClose }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const regions = useSelector(selectRegion.regions);
    const dispatch = useDispatch();
    const isNew = !location;

    const handleSubmit = useCallback((values: Partial<IPois>) => {
        const { position, work_time, name = '', ...args } = values;
        const workTime = Number(work_time);
        const latitude = Number(position?.latitude) || 0;
        const longitude = Number(position?.longitude) || 0;
        const { id = '' } = location || {};
        const params = {
            ...location || {},
            id,
            ...args,
            name,
            type: MAP_ELEMENT.POI,
            position: { latitude, longitude },
            capabilities: [],
            work_time: isNaN(workTime) ? "-" : workTime * 60,
        }
        const { api, handle, successCode, errorCode } = actions[`${isNew}`];
        setLoading(true);
        api(params)
            .then(rs => {
                setLoading(false);
                notify.success(successCode)([params.name]);
                dispatch(handle(rs));
                onClose();
            })
            .catch(error => {
                setLoading(false);
                showErrorResponse(notify[errorCode]([params.name]), error);
            })
    }, [isNew, location, dispatch, onClose]);


    const { work_time = '-' } = location || {};

    return <Row gutter={[0, 16]} className='h-full w-full'>
        <Col span={14} className={styles.form}>
            <Form
                className="pl-1 pr-2"
                form={form}
                onFinish={handleSubmit} layout='vertical'
                initialValues={{
                    ...location || {},
                    work_time: work_time !== '-' ? Math.round(work_time / 60 * 100) / 100 : ''
                }}
            >
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="POI name" name="name" rules={[Rule.Require('Name')]}>
                            <Input className='border-r-40' />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Latitude" name={['position', 'latitude']}
                            rules={[Rule.Require('Latitude'), Rule.Number()]}>
                            <InputNumber className={`border-r-40 w-full ${styles.coordinateInput}`} min={-90} max={90} parser={parserNumber}
                                controls={false} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Longitude" name={['position', 'longitude']}
                            rules={[Rule.Require('Longitude'), Rule.Number()]}>
                            <InputNumber className={`border-r-40 w-full ${styles.coordinateInput}`} min={-180} max={180} parser={parserNumber}
                                controls={false} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Phone" name="phone">
                            <Input className='border-r-40' />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Working time" name="work_time">
                            <Input className={`border-r-40 pl-16 ${styles.workingTimeInput}`} suffix="hours" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Region" name="region_id" rules={[Rule.Require('Region')]}>
                            <Select
                                className={`select-single ${styles.regionSelect}`}
                                placeholder='Region'
                                filterOption={filterOption}
                                options={renderOpts(regions)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {/*<Form.Item name='inventory'>*/}
                {/*    <FormAssignServiceCargo form={form} locationType={MAP_ELEMENT.POI}/>*/}
                {/*</Form.Item>*/}
                <Footer
                    cancel={{ click: onClose }}
                    ok={{ loading, text: isNew ? 'Create new POI' : 'Save' }}
                />
            </Form>
        </Col>
        <Col span={10}>
            <Map form={form} locationType={MAP_ELEMENT.POI} />
        </Col>
    </Row>
}

export const parserNumber = (val?: string) => {
    if (!val) return 0;
    return Number.parseFloat(val.replace(/\$\s?/g, "").replace(/(,)/g, "."))
}

interface IProps {
    location?: IPois

    onClose?(): void
}

const PopupEdit: React.FC<IProps> = ({ location, onClose = () => undefined }) => <WorldMapProvider>
    <Body location={location} onClose={onClose} />
</WorldMapProvider>;

export default PopupEdit;
